import React from 'react';
import { sprintf } from 'sprintf-js';
import styled from 'styled-components';

import { Box } from 'components/Box';
import Icon from 'components/Icon/Icon';
import DropdownMenu, {
  TrackedDropdownMenuItem,
} from 'components/Page/PageHeaderDropdownMenu';
import SimpleTooltip from 'components/SimpleTooltip';
import { LANGUAGES } from 'utils/constants';
import { createCookie } from 'utils/cookies';

const Title = styled(({ open, ...props }) => (
  <SimpleTooltip
    text={getText('Change Language')}
    offsetBottom={14}
    disabled={open}
    xl
  >
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <div {...props}>
      <Icon
        display="block"
        name="language-selection"
        fill="currentColor"
        opacity={0.8}
        width={13}
        height={13}
      />
      <Box
        position={[null, null, null, open ? 'absolute' : null, 'static']}
        left={32}
        display={[null, null, null, open ? 'inline' : 'none', 'inline']}
        component="span"
        ml="6px"
      >
        {CURRENT_LOCALE.toUpperCase()}
      </Box>
    </div>
  </SimpleTooltip>
))`
  display: flex;
  align-items: center;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const LanguageSelectionMenu = ({
  url,
  ...props
}: {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  url: Record<string, any>;
}) => (
  <DropdownMenu
    hideArrow={{
      lg: true,
    }}
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/no-unstable-nested-components
    title={(open) => <Title open={open} />}
    data-qa-id="language-dropdown"
    aria-label={getText('Select language')}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {() =>
      Object.keys(LANGUAGES)
        .filter((key) => key !== CURRENT_LOCALE)
        .map((key) => (
          <TrackedDropdownMenuItem
            key={key}
            disabled={!url[key]}
            href={url[key] || null}
            onClick={() => createCookie('_LOCALE_', key, 1825)}
            title={
              !url[key]
                ? sprintf(
                    /* TRANSLATORS: Tooltip message letting user know page is not yet
                     * translated when hovering over disabled language selection link. */
                    getText('This page is not translated in %(languages)s'),
                    {
                      languages: LANGUAGES[key],
                    }
                  )
                : ''
            }
            data-qa-id={
              url[key] ? `locale-link-${key}` : `disabled-locale-link-${key}`
            }
            eventName={url[key] ? 'Change Language' : undefined}
            eventProperties={
              url[key]
                ? {
                    locale: key,
                  }
                : undefined
            }
          >
            {LANGUAGES[key]}
          </TrackedDropdownMenuItem>
        ))
    }
  </DropdownMenu>
);

// eslint-disable-next-line import/no-default-export
export default LanguageSelectionMenu;
